mobileSize = 1300;

function placeHeaderLogo() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.header-logo').prependTo('.header-top');
  } else {
    $('.header-logo').prependTo('.header-main-top');
  }
}

function placeHeaderButtons() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.mobile-buttons').appendTo('.header');
  }
}

function removeButtonClass() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems1 a').removeClass('button');
  }
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1300) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1301) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Header Logo
  placeHeaderLogo();

  // Header Buttons
  placeHeaderButtons();

  // Email Signup
  $('.footer .emailSignup .emailSignupText').text('SIGN UP FOR THE LATEST ENTERTAINMENT UPDATES');
  $('.footer .emailSignup .emailSubmitButton').text('Subscribe');
  $('.footer .emailSignup .textbox')
    .attr('value', 'Email Address:')
    .attr('onclick', 'ClearDefaultText(this, "Email Address:")');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  // Remove Button Class
  removeButtonClass();
});

$(window).resize(function(){
  // Header Logo
  placeHeaderLogo();

  // Header Buttons
  placeHeaderButtons();

  // Remove Button Class
  removeButtonClass();
});